import type { PromoCode } from '~/modules/promocodes/model'

export const initialPromoCode: PromoCode = {
  carriers: [],
  number: 0,
  currentUses: 0,
  discountOnShippingCosts: 0,
  fromCountries: [],
  key: '',
  maxUses: 0,
  toCountries: [],
  validFrom: '',
  validUntil: '',
}
